import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from './http/http.service';
import { HttpClient, HttpHeaders, HttpBackend } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ComplianceService {
    private directHttp: HttpClient;
  constructor(private http: HttpClient, private httpService: HttpService,    private defaultHttp: HttpClient,
    private httpBackend: HttpBackend
  ) {
    // This HttpClient does NOT use interceptors
    this.directHttp = new HttpClient(httpBackend);
  } 

getCompliancemenuList(): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-access-token': token || ''
    });

    return this.directHttp.get(`${environment.goEvaUrl}getcompliancemenulist`, { headers }) .pipe(
        map(response => response) // Remove map if not transforming the response
      );
  }



  addCompliance(newCompliance) {

      var request = {
          URL: "compliancemenu/add",
          DATA: newCompliance
      }
      return this.httpService.post(request);

  }


  updateCompliance(newCompliance) {

      var request = {
          URL: "compliancemenu/update",
          DATA: newCompliance
      }
      return this.httpService.post(request);

  }

  addsubnode(newCompliance) {
      
              var request = {
                  URL: "compliancemenu/addsubnode",
                  DATA: newCompliance
              }
              return this.httpService.post(request);
      
          }

}
